<template>
  <div class="swiperBox">
    <!-- <div class="directionIcon">
      <div class="imgLeft" @click="clickLeft"></div>
      <div class="imgRight" @click="clickRight"></div>
    </div> -->
    <div class="swiper">
      <div
        :class="swiperClass + ' imgBoxall'"
        @mouseenter="enter"
        @mouseleave="leave"
      >
        <div class="star-li imgDiv" v-for="item in showData" :key="item.id">
          <div class="star-bed">{{ item.bedName }}</div>
          <div class="star-h">
            活力值：{{ item.vitalityIndex }}
            <img
              src="../../../assets/icon_GoUp.png"
              v-if="item.vitalityIsRise == 1"
              alt=""
            />
            <img
              src="../../../assets/icon_GoDown.png"
              v-if="item.vitalityIsRise == -1"
              alt=""
            />
            <img
              src="../../../assets/icon_keep.png"
              v-if="item.vitalityIsRise == 0"
              alt=""
            />
          </div>
          <div class="star-q">
            情绪值：{{ item.moraleIndex }}
            <img
              src="../../../assets/icon_GoUp.png"
              v-if="item.moraleIsRise == 1"
              alt=""
            />
            <img
              src="../../../assets/icon_GoDown.png"
              v-if="item.moraleIsRise == -1"
              alt=""
            />
            <img
              src="../../../assets/icon_keep.png"
              v-if="item.moraleIsRise == 0"
              alt=""
            />
          </div>
          <div class="star-d">
            跌倒风险指数：{{ item.fallIndex }}
            <img
              src="../../../assets/icon_GoUp.png"
              v-if="item.fallIsRise == 1"
              alt=""
            />
            <img
              src="../../../assets/icon_GoDown.png"
              v-if="item.fallIsRise == -1"
              alt=""
            />
            <img
              src="../../../assets/icon_keep.png"
              v-if="item.fallIsRise == 0"
              alt=""
            />
          </div>
          <div class="star-check" @click="details(item.bedId, item.bedName)">
            查看完整报告
          </div>
          <div class="star-score">
            <div class="score">{{ item.score }}</div>
            <div class="score-title">睡眠得分</div>
          </div>
        </div>
      </div>
      <div class="show-empty" v-show="showEmpty">暂未订购</div>
    </div>
  </div>
</template>
<script>
export default {
  // speed:速度  direction:方向 showData:展示的数据  showEmpty：是否显示空数据提示
  props: {
    speed: Number,
    direction: String,
    showData: Array,
    showEmpty: Boolean,
    swiperClass: String,
  },
  data() {
    return {
      imgList: [],
      timer: null,
      theSpeed: this.speed,
      imgWidth: 100,
      theDirection: this.direction,
    };
  },
  created() {},
  mounted() {},
  methods: {
    details(bedId, bedName) {
      console.log("1111111");
      var scope = {
        bedId: bedId,
        bedName: bedName,
        activeType: 1,
      };
      this.$parent.$parent.details(scope);
    },
    //   左边
    clickLeft() {
      this.theDirection = "left";
    },
    // 右边
    clickRight() {
      this.theDirection = "right";
    },
    // 移入
    enter() {
      this.timer = clearInterval(this.timer);
    },
    leave() {
      this.move(this.swiperClass);
    },
    move(name) {
      var imgBox = document.getElementsByClassName(name)[0];
      imgBox.innerHTML += imgBox.innerHTML;
      //   var imgDiv = document.getElementsByClassName("imgDiv");
      //   imgBox.style.width = imgDiv.length * this.imgWidth + "px"; //设置ul的宽度使图片可以放下
      let that = this;
      function autoScroll() {
        if (imgBox.offsetLeft < -(imgBox.offsetWidth / 2)) {
          //向左滚动
          imgBox.style.left = 0;
        }
        if (imgBox.offsetLeft > 0) {
          //向右滚动
          imgBox.style.left = -(imgBox.offsetWidth / 2) + "px";
        }
        if (that.theDirection == "left") {
          that.theSpeed = -Math.abs(that.theSpeed);
        } else {
          that.theSpeed = Math.abs(that.theSpeed);
        }
        imgBox.style.left = imgBox.offsetLeft + that.theSpeed + "px";
        // if(name=='imgBox2'){

        //     console.log('left111:',imgBox.offsetLeft)
        //     console.log('left:',imgBox.style.left)
        // }
      }
      clearInterval(this.timer);
      this.timer = setInterval(autoScroll, 30); //全局变量 ，保存返回的定时器
    },
  },

  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style scoped lang="scss">
.show-empty {
  text-align: center;
  color: #8c8c8c;
  line-height: 20px;
  font-size: 16px;
  margin-top: 80px;
}
.swiperBox {
  height: 200px;
  width: 97%;
  margin: 0px auto;
  position: relative;
}
.swiperBox .directionIcon {
  position: absolute;
  top: 45%;
  width: 100%;
  left: -10%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  opacity: 0.5;
  z-index: 9;
  pointer-events: none;
}

.swiperBox .directionIcon .imgLeft {
  position: absolute;
  left: 80px;
  width: 100px;
  height: 100px;
  background-size: 80%;
  background: red;
  cursor: pointer;
}

.swiperBox .directionIcon .imgRight {
  position: absolute;
  right: -160px;
  width: 100px;
  height: 100px;
  background-size: 80%;
  background: red;
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  cursor: pointer;
}
.swiperBox .swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
// .swiperBox .swiper .imgBox {
//   position: absolute;
//   left: 0;
//   top: 0;
//   overflow: hidden;
//   display: -webkit-box;
//   display: -ms-flexbox;
//   display: flex;
// }
// .swiperBox .swiper .imgBox .imgDiv {
//   //   width: 240px;
//   //   height: 365px;
//   //   margin-left: 15px;
//   cursor: pointer;
// }
// .swiperBox .swiper .imgBox .imgDiv img {
//   height: 100%;
//   width: 100%;
// }

.swiperBox .swiper .imgBoxall {
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.swiperBox .swiper .imgBoxall .imgDiv {
  //   width: 240px;
  //   height: 365px;
  //   margin-left: 15px;
  cursor: pointer;
}
.swiperBox .swiper .imgBoxall .imgDiv img {
  height: 100%;
  width: 100%;
}

.star-li {
  width: 210px;
  height: 185px;
  background: #ffffff;
  box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  margin-top: 10px;
  position: relative;
  display: inline-block;
  margin-left: 10px;
  .star-score {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 62px;
    height: 62px;
    border-radius: 31px;
    border: 3px solid #1890ff;
    text-align: center;
    .score {
      font-size: 22px;
      color: #262626;
      line-height: 24px;
      margin-top: 4px;
    }
    .score-title {
      font-size: 10px;
      color: #8c8c8c;
      line-height: 12px;
    }
  }
  .star-bed {
    overflow: hidden;
    text-overflow: ellipsis; //显示省略号
    display: -webkit-box;
    -webkit-line-clamp: 2; //块元素显示的文本行数
    -webkit-box-orient: vertical;
    // white-space: nowrap;
    width: 120px;
    margin-left: 10px;
    margin-top: 20px;
    color: #262626;
    line-height: 18px;
    font-size: 14px;
    height: 40px;
  }
  .star-h {
    color: #262626;
    line-height: 20px;
    font-size: 14px;
    display: inline-block;
    margin-left: 10px;
    margin-top: 20px;
  }
  .star-q {
    color: #262626;
    line-height: 20px;
    font-size: 14px;
    display: inline-block;
    margin-left: 10px;
    margin-top: 20px;
  }
  .star-d {
    color: #262626;
    line-height: 20px;
    font-size: 14px;
    display: inline-block;
    margin-left: 10px;
    margin-top: 10px;
  }
  .star-h,
  .star-q,
  .star-d {
    img {
      width: 12px !important;
      position: relative;
      top: -2px;
      margin-left: 3px;
    }
  }
  .star-check {
    width: 190px;
    height: 32px;
    background: #1890ff;
    border-radius: 2px;
    color: white;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    margin-left: 10px;
    margin-top: 10px;
    cursor: pointer;
  }
}
</style>